import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 5.25a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.793 22.112l4.966-8.602a1.5 1.5 0 00-1.299-2.25H3m10.974 4.365l-3.75 6.495M14 11.25h7"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 5.25a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.793 22.112l4.966-8.602a1.5 1.5 0 00-1.299-2.25H3m10.974 4.365l-3.75 6.495M14 11.25h7"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 10.5a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.586 44.224l9.932-17.203c1.154-2-.29-4.5-2.598-4.5H6m21.947 8.729l-7.5 12.99M28 22.5h14"
  }))
};
export var MuscleGroup = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});